import {Component} from "vue-mixin-decorator";
import {Vue} from "vue-property-decorator";
import {Entities} from "@/store/Database";
import {HdsCollectionMap} from "@/store/modules/hds";
import {DataComponentModel, Dictionary, ServiceComponentModel} from "@/store/modules/hds/Model";
import {mapGetters} from "vuex";

/**
 * データソース
 */
@Component({
  ...mapGetters({
    entities: 'hds/entities',
  }),
})
export default class DataSourceMixin extends Vue {
  /** すべての hds entity */
  private entities!: Entities<HdsCollectionMap>;

  /** 辞書*/
  private dictionary!: Dictionary;

  /**
   * 辞書に関連するすべてのデータ構成モデルを取得します
   */
  get dataComponentModels(): DataComponentModel[] {
    const dictionaryIds = [this.dictionary.id];
    if(this.dictionary.dictionaryType === 'external' && this.dictionary.sourceDictionaryId) {
      dictionaryIds.push(this.dictionary.sourceDictionaryId);
    }
    return this.entities.dataComponentModel
        .find({dictionaryId: {$in: dictionaryIds}});
  }

  /**
   * 辞書に関連するすべてのサービス構成モデルを取得します
   */
  get serviceComponentModels(): ServiceComponentModel[] {
    const dictionaryIds = [this.dictionary.id];
    if(this.dictionary.dictionaryType === 'external' && this.dictionary.sourceDictionaryId) {
      dictionaryIds.push(this.dictionary.sourceDictionaryId);
    }
    return this.entities.serviceComponentModel
        .find({dictionaryId: {$in: dictionaryIds}});
  }
}
